<template>
  <v-container fill-height>
    <v-layout row justify-center align-center>
      <p>{{ $t('message.login.error.' + this.errorType) }}</p>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    errorType: {
      type: String,
      default: 'generic'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginError.vue